import { render, staticRenderFns } from "./editPopover.vue?vue&type=template&id=59964572"
import script from "./editPopover.vue?vue&type=script&lang=js"
export * from "./editPopover.vue?vue&type=script&lang=js"
import style0 from "./editPopover.vue?vue&type=style&index=0&id=59964572&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports